import { Controller } from "@hotwired/stimulus"

// One-shot "Add note" reveal used inside the Add Provider drawer's per-item
// settings panel. On click of the "Add note" link, hides the link, reveals
// the notes label + textarea, and focuses the textarea so the user can start
// typing immediately.
export default class extends Controller {
  static targets = ["link", "field", "input"]

  reveal(event) {
    if (event) event.preventDefault()
    if (this.hasLinkTarget) this.linkTarget.classList.add("hidden")
    if (this.hasFieldTarget) this.fieldTarget.classList.remove("hidden")
    if (this.hasInputTarget) this.inputTarget.focus()
  }
}
